import axios from 'axios';

const state= {
    EquipmentBrand:{
        items:[],
        total:0
    },
    EquipmentBrandLoadings:{
        list:true
    }
};

const getters = {
    EquipmentBrand : (state) => state.EquipmentBrand,
    EquipmentBrandLoadings : (state) => state.EquipmentBrandLoadings,
};

const actions = {
    async getItemsWithType({commit}, params){
        let typeId = params;
        return new Promise (( resolve, reject ) => {
            commit( 'setEquipmentBrandLoadings', {key:"list",val:true});
            global.axios.get(`api/equipment/brands`, {params:{
                    equipment_group_id:typeId,
                }})
                .then(response => {
                    commit( 'setEquipmentBrandLoadings', {key:"list",val:false});
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.EquipmentBrand.items = data;
        state.EquipmentBrand.total = data.length;
    },
    setEquipmentBrandLoadings (state,data) {
        if(data.key === "list"){
            state.EquipmentBrandLoadings.list = data.val;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}